import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';
import { ShoppingCart, Menu, User, Package } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { Badge } from '../ui/badge';
import { Logo } from './Logo';

export const Header = () => {
  const { cartCount, user, logout } = useCart();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full bg-white/80 backdrop-blur supports-[backdrop-filter]:bg-white/70 border-b border-border">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <Logo size="default" />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-6">
          <Link to="/products?category=lunchbox" className="text-sm font-medium hover:text-[hsl(var(--primary))] transition-colors">
            Lunchboxes
          </Link>
          <Link to="/products?category=bag" className="text-sm font-medium hover:text-[hsl(var(--primary))] transition-colors">
            School Bags
          </Link>
          {user ? (
            <>
              <Link to="/orders" className="text-sm font-medium hover:text-[hsl(var(--primary))] transition-colors flex items-center gap-1">
                <Package className="w-4 h-4" />
                My Orders
              </Link>
              <Button variant="ghost" size="sm" onClick={logout}>
                Logout
              </Button>
            </>
          ) : null}
        </nav>

        {/* Actions */}
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            className="relative"
            onClick={() => navigate('/cart')}
            data-testid="header-cart-button"
          >
            <ShoppingCart className="w-5 h-5" />
            {cartCount > 0 && (
              <Badge className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 text-xs rounded-full">
                {cartCount}
              </Badge>
            )}
          </Button>

          {/* Mobile Menu */}
          <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
            <SheetTrigger asChild className="md:hidden">
              <Button variant="ghost" size="icon">
                <Menu className="w-5 h-5" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px]">
              <div className="flex flex-col gap-4 mt-8">
                <Link
                  to="/products?category=lunchbox"
                  className="text-lg font-medium hover:text-[hsl(var(--primary))] transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  🍱 Lunchboxes
                </Link>
                <Link
                  to="/products?category=bag"
                  className="text-lg font-medium hover:text-[hsl(var(--primary))] transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  🎒 School Bags
                </Link>
                {user ? (
                  <>
                    <Link
                      to="/orders"
                      className="text-lg font-medium hover:text-[hsl(var(--primary))] transition-colors"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      📦 My Orders
                    </Link>
                    <Button onClick={logout} className="w-full mt-4">
                      Logout
                    </Button>
                  </>
                ) : null}
                <div className="pt-4 border-t mt-4">
                  <Link to="/admin" className="text-sm text-muted-foreground hover:text-foreground">
                    Admin Panel
                  </Link>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};